<template>
    <div class="topic-combination">
        <div v-if="!subQuestions.length" class="combo-empty">暂无子题数据</div>
        <div
            v-for="(list, index) in subQuestions"
            :key="subKey(list, index)"
            class="combo-sub-block"
        >
            <div class="topic-label">
                <span class="label-type">{{ setQuestionType(item) }}</span>
                <div class="label-tit">
                    <!-- <span v-if="subQuestions.length > 1" class="sub-index">（{{ index + 1 }}）</span> -->
                    {{ list.question }}
                </div>
            </div>
            <el-radio-group
                v-model="list.answer"
                class="option-group"
                :disabled="list.submitted"
                v-removeAriaHidden
            >
                <div
                    class="option-row"
                    v-for="(opt, optIndex) in optionsFor(list)"
                    :key="'r-' + optIndex"
                >
                    <el-radio :label="opt.value">{{ opt.label }}</el-radio>
                </div>
            </el-radio-group>
            <div class="item-answer" v-if="!list.submitted">
                <el-button type="primary" :loading="list._submitting" @click="submit(list)">
                    查看答案
                </el-button>
            </div>
            <!-- 每道子题提交后，结果展示在本题下方 -->
            <div v-if="list.feedback" class="sub-result-panel">
                <div class="result-row user-row" v-if="list.feedback.inputAnswer != null && list.feedback.inputAnswer !== ''">
                    <span class="result-label">您的答案：</span>
                    <span class="user-answer-text">{{ list.feedback.inputAnswer || '未填写' }}</span>
                    <i
                        class="result-icon"
                        :class="{
                            'correct el-icon-success': list.feedback.isCorrect,
                            'wrong el-icon-circle-close': !list.feedback.isCorrect,
                        }"
                    />
                </div>
                <div class="result-row ref-row" v-if="list.feedback.correctAnswer">
                    <span class="result-label">参考答案：</span>
                    <span class="ref-answer-text" v-html="list.feedback.correctAnswer"></span>
                </div>
                <div v-if="list.feedback.analysis" class="result-analysis">{{ list.feedback.analysis }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getQuestionTypeLabel } from './topicQuestionTypes.js';
import { confirmAnswer } from '../../../io/api';

export default {
    name: 'TopicCombinationChoice',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        subQuestions() {
            const raw = this.item && this.item.questionMapList;
            return Array.isArray(raw) ? raw : [];
        },
    },
    watch: {
        item: {
            handler() {
                this.initSubQuestions();
            },
            immediate: true,
        },
    },
    methods: {
        setQuestionType: getQuestionTypeLabel,
        subKey(list, index) {
            return list.value != null ? String(list.value) : `sub-${index}`;
        },
        /** 子题自带选项时用子题；否则共用大题 optionMapList */
        optionsFor(list) {
            const own = list.mapList;
            if (Array.isArray(own) && own.length) return own;
            const shared = this.item.optionMapList; 
            return Array.isArray(shared) ? shared : [];
        },
        initSubQuestions() {
            if (!this.item || !this.subQuestions.length) return;
            this.subQuestions.forEach((row) => {
                if (row.answer === undefined) this.$set(row, 'answer', '');
                if (row.submitted === undefined) this.$set(row, 'submitted', false);
            });
        },
        submit(list) {
            if (list.answer === '' || list.answer == null) {
                this.$message.warning('请选择答案～');
                return;
            }
            this.$set(list, '_submitting', true);
            const apiParams = {
                id: this.item.id,
                answer: list.answer,
                questionFlag: list.value,
            };
            confirmAnswer(apiParams)
                .then((res) => {
                    const { code, data, msg } = res.data;
                    if (code !== 0) {
                        this.$message.error(msg || '提交失败～');
                        return;
                    }
                    this.$set(list, 'feedback', data || {});
                    list.submitted = true;
                    const allDone = this.subQuestions.length
                        ? this.subQuestions.every((row) => row.submitted)
                        : true;
                    this.$emit('submitAnswer', {
                        combination: true,
                        allSubmitsDone: allDone,
                        data: data || {},
                    });
                })
                .finally(() => {
                    this.$set(list, '_submitting', false);
                });
        },
    },
};
</script>

<style lang="less" scoped>
@import './topic-info.less';
.topic-combination {
    .combo-sub-block {
        margin-bottom: 28px;
        padding-bottom: 8px;
        border-bottom: 1px dashed #dcdfe6;
        &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
        }
    }
    .sub-index {
        color: #909399;
        font-size: 14px;
        margin-right: 4px;
    }
    .combo-empty {
        color: #909399;
        font-size: 15px;
        padding: 12px 0;
    }
    .sub-result-panel {
        margin-top: 16px;
        padding: 16px 20px;
        background: #e8f2ff;
        border: 1px solid #c0d9f6;
        border-radius: 4px;
        .result-row {
            display: flex;
            align-items: flex-start;
            margin-bottom: 10px;
            font-size: 15px;
            line-height: 1.8;
            &.user-row {
                align-items: center;
            }
            &:last-of-type {
                margin-bottom: 0;
            }
            .result-label {
                flex-shrink: 0;
                color: #303133;
                font-weight: bold;
                margin-right: 8px;
            }
            .user-answer-text {
                color: #386de8;
                font-weight: bold;
                margin-right: 8px;
            }
            .ref-answer-text {
                color: #67c23a;
                font-weight: bold;
            }
            .result-icon {
                font-size: 1.2em;
                &.correct {
                    color: #67c23a;
                }
                &.wrong {
                    color: #f56c6c;
                }
            }
        }
        .result-analysis {
            margin-top: 8px;
            padding-top: 10px;
            border-top: 1px dashed #b3d4fc;
            font-size: 14px;
            color: #606266;
            line-height: 1.8;
        }
    }
}
</style>
